import { NgModule } from '@angular/core';

import { FocusOutDirective } from './focus-out.directive';

@NgModule({
  declarations: [FocusOutDirective],
  exports: [FocusOutDirective],
})
export class FocusOutDirectiveModule {}
